export const colorArray = [
  "Blue", "BlueViolet", "Brown", "Chocolate", "Crimson", "DarkBlue", "DarkGoldenrod", "DarkKhaki", "DarkMagenta", "DarkOrchid",
  "DarkRed", "DarkSlateBlue", "DarkSlateGray", "DimGray", "FireBrick", "Goldenrod", "Gray", "HotPink", "IndianRed", "Indigo",
  "Khaki", "LightGray", "LightPink", "LightSlateGray", "Maroon", "MediumBlue", "MediumOrchid", "MediumPurple", "MediumSlateBlue", "MediumVioletRed",
  "MidnightBlue", "Magenta", "Navy", "Orchid", "PaleVioletRed", "Peru", "Pink", "Plum", "Purple", "Red", "RosyBrown",
  "SaddleBrown", "SandyBrown", "Sienna", "SlateBlue", "SlateGray", "Thistle", "Violet"
];

